import { render, staticRenderFns } from "./functionSwitch.vue?vue&type=template&id=9a30cb12&scoped=true"
import script from "./functionSwitch.vue?vue&type=script&lang=js"
export * from "./functionSwitch.vue?vue&type=script&lang=js"
import style0 from "./functionSwitch.vue?vue&type=style&index=0&id=9a30cb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a30cb12",
  null
  
)

export default component.exports